import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { environment } from "../../../../environments/environment";
import { Description, DescriptionFull } from "./description.model";
import { HttpClient } from "@angular/common/http";
import { share } from "rxjs/operators";

const API_ENDPOINT = environment.API_ENDPOINT + "/descriptions";

@Injectable()
export class DescriptionService {
  patients: Observable<Array<Document>>;

  constructor(private http: HttpClient) {}

  listDescriptions(type: string): Observable<Description[]> {
    return this.http.get<Description[]>(`${API_ENDPOINT}/${type}`);
  }

  getFullDescriptions(type: string): Observable<DescriptionFull> {
    return this.http
      .get<DescriptionFull>(`${API_ENDPOINT}/${type}/full`)
      .pipe(share());
  }

  getDescription(type: string, identifier: string): Observable<Description> {
    return this.http.get<Description>(`${API_ENDPOINT}/${type}/${identifier}`);
  }

  saveDescription(description: Description): Observable<Description> {
    return this.http.post<Description>(
      `${API_ENDPOINT}/${description.type}/${description.identifier}`,
      description,
    );
  }

  resetDescription(type: string, identifier: string): Observable<Description> {
    return this.http.delete<Description>(
      `${API_ENDPOINT}/${type}/${identifier}`,
    );
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/description/description.service.ts